import { DEFAULT } from '../../../shared/constants/defaults';
import { QUALIFICATIONS_CATEGORIES } from '../../../shared/constants/qualification-categories';
import {
  IndividualQuota,
  NestedQuota,
} from '../../../shared/interfaces/quota.interface';
import { RandomStringGenerator } from '../../../shared/utils/random-string-generator';

interface GroupSeparator {
  ungroup(): NestedQuota[];
}

export class NestedQuotaGroupSeparator implements GroupSeparator {
  constructor(private readonly _groupedQuota: NestedQuota) {}

  public ungroup(): NestedQuota[] {
    return (this._groupedQuota.individual_quotas ?? []).map(
      (individualQuota) => ({
        ...this._each(individualQuota),
      })
    );
  }

  private _each(individualQuota: IndividualQuota): NestedQuota {
    const {
      combinedKey,
      allocation: {
        max: maximum = 0,
        min: minimum = 0,
        quantity: number = 0,
        fielded = 0,
        percentage = 0,
      } = {},
      criteria,
    } = individualQuota;
    return {
      buyer_quota_id: new RandomStringGenerator().generate(),
      combinedKey,
      required_count: number,
      number,
      minimum,
      maximum,
      fielded,
      percentage,
      criteria,
      quota_category: QUALIFICATIONS_CATEGORIES.NESTED,
      group_key: this._groupedQuota.group_key || DEFAULT.NESTED_GROUP_KEY,
    };
  }
}
